import { Link, Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "@/components/layout/Sidebar";
import { Topbar } from "@/components/layout/Topbar";
import { LiveCoachOverlay } from "@/components/live/LiveCoachOverlay";
import LiveCapture from "@/pages/LiveCapture";

export function AppShell() {
    const location = useLocation();
    const isLiveRoute = location.pathname === "/live";

    return (
        <div className="flex min-h-screen bg-obsidian">
            <Sidebar />
            <div className="flex-1 flex flex-col min-w-0">
                <Topbar />
                <main className="flex-1 px-4 lg:px-7 py-6 lg:py-8 max-w-[1500px] w-full mx-auto">
                    {/* Preserve active recording across navigation without covering the selected screen. */}
                    <div className={isLiveRoute ? "block" : "hidden"} aria-hidden={!isLiveRoute}>
                        <LiveCapture />
                    </div>
                    <Outlet />
                </main>
                <footer data-testid="app-footer" className="border-t border-border px-4 lg:px-7 py-4 text-center">
                    <p className="text-[11px] text-muted-foreground font-mono tracking-wide">
                        &copy; WhiteWater AI 2026 &middot; Veteran Owned and Operated <span className="not-italic" aria-label="American flag">&#127482;&#127480;</span>
                        <span className="mx-2">&middot;</span><Link to="/privacy" className="hover:text-white">Privacy</Link>
                        <span className="mx-2">&middot;</span><Link to="/terms" className="hover:text-white">Terms</Link>
                    </p>
                </footer>
            </div>
            <LiveCoachOverlay />
        </div>
    );
}
